import Chip from './chip';

export { chipVariants, type ChipVariantProps } from './variants';
export { type ChipProps } from './chip';

export default Chip;
